// Warning: Import directly from the specific file to avoid circular dependency errors when using util
import { getPercentileOptions } from 'pages/ValuationsAllocation/util/getPercentileOptions';

const percentileOptions = getPercentileOptions([...Array(99)]);

const GET_PERCENTILE_OPTION = value => percentileOptions[value - 1].label;

export default GET_PERCENTILE_OPTION;
